// extracted by mini-css-extract-plugin
export default {"form":"OnboardingVerifyCodeForm_form__UhwOU","fieldset":"OnboardingVerifyCodeForm_fieldset__Hm+yM","footer":"OnboardingVerifyCodeForm_footer__jEM38"};